import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '../store';
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }     
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/analisis/:id',
    name: 'Analisis',
    component: () => import('../views/Analisis.vue')
  },
  {
    path: '/veranalisis/:id',
    name: 'VerAnalisis',
    component: () => import('../views/VerAnalisis.vue')
  },
  {
    path: '/diagnostico/:id',
    name: 'Diagnostico',
    component: () => import('../views/Diagnostico.vue')
  },
  {
    path: '/listadoanalisis/:id',
    name: 'ListadoAnalisis',
    component: () => import('../views/ListadoAnalisis.vue')
  },  
  {
    path: '/seguimiento',
    name: 'Seguimiento',
    component: () => import('../views/Seguimiento.vue')
  },
  {
    path: '/verinforme/:id',
    name: 'VerInforme',
    component: () => import('../views/VerInforme.vue')
  },

  {
    path: '/seg2',
    name: 'Seg2',
    component: () => import('../views/Seg2.vue')
  },
  {
    path: '/generarinforme',
    name: 'GenerarInforme',
    component: () => import('../views/GenerarInforme.vue')
  },
  {
    path: '/sendemail',
    name: 'SendEmail',
    component: () => import('../views/SendEmail.vue')
  },
  //  {
  //    path: '/guardarvalores',
  //    name: 'guardarvalores',
  //    component: () => import('../views/guardarvalores.vue')
  //  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  let loginUsuario = to.matched.some(ruta => ruta.meta.requiresAuth)
  console.log(loginUsuario);

  if(loginUsuario && !store.state.uidUser){
    next('login')
  }else {
    next()
  }
})

export default router